export default {
  title01: "Jelenlegi időjárás",
  title02: "24 óra",
  title03: "10 napos időjárás-előrejelzés megtekintése",
  title04: "Légminőség-index",
  title05: "Minden információ megtekintése",
  title06: "Napkelte és napnyugta",
  title07: "A hold fázisa",
  title08: "A következő telihold",
  title09: "A következő újhold",
  title10: "NAPpal",
  title11: "ÉJSZAKA",
  title12: "Napkelte",
  title13: "Napnyugta",
  title14: "Holdkelte",
  title15: "Holdnyugta",
  title16: "Forrás",
  title17: "Kezdés",
  title18: "Befejezés",
  title19: "Jelenlegi hely használata",
  title20: "Város keresése",
  title21: "Érzékelt hőmérséklet",
  title22: "Érzékelt hőmérséklet árnyékban",
  title23: "Most",
  title24: "Ma",
  title25: "NAP",
  title26: "HÉTFŐ",
  title27: "KEDD",
  title28: "SZERDA",
  title29: "CSÜTÖRTÖK",
  title30: "PÉNTEK",
  title31: "SZOMBAT",
  title32: "Betöltés...",
  title33: "Most",
  title34: "Óránként",
  title35: "Napi",
  title36: "Nap és Hold",
  title37: "Levegőminőség",
  title38: "Kapcsolat: xlf550402@gmail.com",
  title39: "Adatvédelmi nyilatkozat",
  title40: "Szerzői jog © comfortweather.com 2020 - 2025. Minden jog fenntartva.",
  title41: "Az adatokat szolgáltatja",
  title42: "Max.",
  title43: "Min.",
  title44: "Elfogadom",
  title45:
    "Köszönjük, hogy a ComfortWeather-t választotta! Az Ön törvényes jogainak és érdekeinek védelme érdekében, kérjük, használat előtt olvassa el az ",
  title46: "Adatvédelmi Tájékoztatót",
  title47: " .",
  title48: "",
  title49: "Kapcsolat: xyjph123@gmail.com",
  title50: "Szerzői jog © 24hweather.com 2020 - 2025. Minden jog fenntartva.",
  title51:
    "Köszönjük, hogy a 24hweather-t választotta! Az Ön törvényes jogainak és érdekeinek védelme érdekében, kérjük, használat előtt olvassa el az ",
};
